import { render } from "./LanguageMenu.vue?vue&type=template&id=a87a2838&ts=true"
import script from "./LanguageMenu.vue?vue&type=script&lang=ts"
export * from "./LanguageMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__